import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'

export interface ArtistReviewFeedbackBody {
  reviewId: number
  feedbackText?: string
  feedback: boolean | null
}

export interface SpotifyCampaignReview {
  curator: {
    firstName: string
    lastName: string
    userPhotoUrl: string
    playlistsCount: number
    followersCount: number
    userId: number
  }
  review: {
    id: number
    artistFeedbackCreatedAt: string
    artistFeedbackStatus: boolean
    artistFeedbackText: string
    comment: string
    reviewDate: string
    reviewStatus: 'reviewed' | 'skipped'
    recommendations: string
    vocalRating: number
    melodyRating: number
    productionRating: number
  }
  matchedPlaylists?: Array<{
    name: string | null
    url: string | null
    playlistCoverUrl?: string | null
    cover?: string | null
  }>
  addedToPlaylist?: {
    name: string
    cover: string
    url: string
  }
}

const artistSpotifyCampaignReviewApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getCampaignReviews: builder.query<Array<SpotifyCampaignReview>, number>({
      query: (campaignId) =>
        `${APP.TIKTOK_SERVER}/artist/reviews/by-campaign/${campaignId}`,
      providesTags: ['SpotifyCampaignReviews'],
    }),

    postArtistReviewFeedback: builder.mutation<void, ArtistReviewFeedbackBody>({
      query: ({ reviewId, feedback, feedbackText }) => ({
        url: `${APP.TIKTOK_SERVER}/artist/reviews/${reviewId}/feedback`,
        method: 'POST',
        body: {
          feedback,
          feedbackText,
        },
      }),
      invalidatesTags: ['SpotifyCampaignReviews'],
    }),

    patchArtistReviewShare: builder.mutation<void, number>({
      query: (reviewId) => ({
        url: `${APP.TIKTOK_SERVER}/artist/reviews/${reviewId}/share`,
        method: 'PATCH',
      }),
    }),
  }),
})
export const {
  usePostArtistReviewFeedbackMutation,
  usePatchArtistReviewShareMutation,
  useGetCampaignReviewsQuery,
} = artistSpotifyCampaignReviewApi
